import React from "react";
import styled from "styled-components";
// State
import { useSelector } from "react-redux";
import { selectMode } from "../app/appSlice";
import PropTypes from "prop-types";
// Router
import { Link, useLocation } from "react-router-dom";
// Images
import defaultLogo from "../images/defaultNavLogo.svg";
// Components
import { Link as ScrollLink } from "react-scroll";
import { Container, Nav, Navbar, NavDropdown } from "react-bootstrap";
import ThemeToggle from "./ThemeToggle";
// Config
import { getNavigationLinks } from "../config/sections";

// #region constants
const navLinks = getNavigationLinks();
// #endregion

// #region styled-components
const StyledDiv = styled.div`
  .navbar {
    border-bottom: var(--border);
  }

  .spacer {
    height: var(--nav-height);
  }

  .logo-img {
    background: ${({ theme }) =>
      theme.name === "light" ? "var(--bs-dark)" : "var(--bs-light)"};
  }

  .dropdown-menu {
    background: ${({ theme }) =>
      theme.name === "light" ? "var(--bs-light)" : "var(--bs-dark)"};
    border: var(--border);
  }

  .dropdown-item {
    color: ${({ theme }) =>
      theme.name === "light" ? "var(--bs-dark)" : "var(--bs-light)"};
    &:hover {
      background: ${({ theme }) =>
        theme.name === "light" ? "var(--bs-gray-200)" : "var(--bs-gray-700)"};
    }
  }
`;
// #endregion

// #region component
const propTypes = {
  Logo: PropTypes.node,
  callBack: PropTypes.func,
  closeDelay: PropTypes.number,
};

const NavBar = ({ Logo = defaultLogo, callBack, closeDelay = 125 }) => {
  const theme = useSelector(selectMode);
  const [isExpanded, setisExpanded] = React.useState(false);
  const { pathname } = useLocation();
  
  const handleNavClose = () => {
    setTimeout(() => {
      setisExpanded(false);
    }, closeDelay);
  };

  return (
    <StyledDiv theme={{ name: theme }}>
      <div className="spacer" />
      <Navbar
        id="nav"
        collapseOnSelect={true}
        expand="xl"
        expanded={isExpanded}
        bg={theme === "light" ? "light" : "dark"}
        variant={theme === "light" ? "light" : "dark"}
        fixed="top"
      >
        <Container>
          <Navbar.Brand>
            <img
              alt="Logo"
              src={Logo === null ? defaultLogo : Logo}
              width="35"
              height="35"
              className="rounded-circle logo-img"
            />
          </Navbar.Brand>
          <Navbar.Toggle
            aria-controls="responsive-navbar-nav"
            onClick={() => setisExpanded(!isExpanded)}
          />
          <Navbar.Collapse id="responsive-navbar-nav">
            <Nav navbarScroll className="me-auto">
              {pathname === "/" ? (
                <>
                  <NavDropdown title="Home" id="home-dropdown">
                    {navLinks.to.map((el) => (
                      <NavDropdown.Item key={el.id}>
                        <ScrollLink
                          to={el.to}
                          spy={true}
                          activeClass="active"
                          onClick={handleNavClose}
                        >
                          {el.name}
                        </ScrollLink>
                      </NavDropdown.Item>
                    ))}
                  </NavDropdown>
                  {navLinks.routes.filter(el => el.route !== "/").map((el) => (
                    <Nav.Item key={el.id}>
                      <Link
                        to={el.route}
                        className="nav-link"
                        onClick={handleNavClose}
                      >
                        {el.name}
                      </Link>
                    </Nav.Item>
                  ))}
                </>
              ) : (
                <>
                  <Nav.Item>
                    <Link
                      to="/"
                      className={pathname === "/" ? "nav-link active" : "nav-link"}
                      onClick={handleNavClose}
                    >
                      Home
                    </Link>
                  </Nav.Item>
                  {navLinks.routes.filter(el => el.route !== "/").map((el) => (
                    <Nav.Item key={el.id}>
                      <Link
                        to={el.route}
                        className={
                          pathname === el.route
                            ? "nav-link active"
                            : "nav-link"
                        }
                        onClick={handleNavClose}
                      >
                        {el.name}
                      </Link>
                    </Nav.Item>
                  ))}
                </>
              )}
            </Nav>
            <Nav>
              <ThemeToggle
                closeDelay={closeDelay}
                setExpanded={setisExpanded}
                setTheme={callBack}
              />
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
    </StyledDiv>
  );
};

NavBar.propTypes = propTypes;
// #endregion

export default NavBar;
